import { Box, Typography } from '@mui/material';
import { extractYouTubeId } from '../../../utils/extractYouTubeId';

interface EventVideoProps {
    videoUrl?: string;
    title?: string;
}

export function EventVideo({ videoUrl, title }: EventVideoProps) {
    if (!videoUrl) return null;

    const youtubeId = extractYouTubeId(videoUrl);
    if (!youtubeId) return null;

    return (
        <Box sx={{ mb: 3 }}>
          
            <Box
                sx={{
                    position: 'relative',
                    width: '100%',
                    paddingTop: '56.25%', // 16:9 aspect ratio
                    borderRadius: 2,
                    overflow: 'hidden',
                    bgcolor: 'black',
                }}
            >
                <iframe
                    width="100%"
                    height="100%"
                    src={`https://www.youtube.com/embed/${youtubeId}`}
                    title="Vídeo do evento"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                    }}
                />
            </Box>
        </Box>
    );
}

